import styled from 'styled-components';

export const ShipUtilizationContainer = styled.div`
    bottom: 0;
    left: -240px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ShipUtilizationBottomPanel = styled.div`
    flex: 0 0 auto;
    display: flex;
    justify-content: space-evenly;
    line-height: 1.15;
    font-size: 0.65rem;
    font-weight: 600;
    padding: 2px 5px;
    gap: 7px;
    height: 20px;
    border: 1px solid ${({ theme }) => theme.colors.border.ccc};
    border-top-style: solid;
    background: ${({ theme }) => theme.colors.background.lightGrey};
    border-radius: 4px 4px 0 0;
    margin: 0px 0px -7px;

    text-align: right;
    span {
        font-weight: 400;
        padding: 0 2px;
    }
    .separator {
        border-left: 1px solid ${({ theme }) => theme.colors.border.ccc};
        width: 1px;
    }

    label {
        font-weight: 600;
        margin-right: 2px;
    }
`;

export const BottomHelpPanelContainer = styled.div`
    bottom: 35px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: fit-content;
    left: 30%;
`;

export const BottomHelpPanel = styled.div`
    display: flex;
    padding: 1px;
    font-size: 0.75rem;
    height: 35px;
    justify-content: space-between;
    align-items: center;
`;

export const LeftBottomHelpPanel = styled.div`
    flex: 0 0 auto;
    display: flex;
    line-height: 1;
    font-size: 0.65rem;
    font-weight: 600;
    padding: 0 5px;
    gap: 15px;
    height: 24px;
    border: 1px solid ${({ theme }) => theme.colors.border.lightGrey};
    border-top: 0;
    background: ${({ theme }) => theme.colors.background.lightGrey};
    border-radius: 0 0 4px 4px;
    margin: 0 15px 0 0;
    width: 100px;
    box-shadow: ${({ theme }) => theme.colors.shadow.ccc} 0px 3px 5px 0px;
    padding: 2px 0 0 5px;
    span {
        font-weight: 400;
    }
    .separator {
        border-left: 1px solid ${({ theme }) => theme.colors.border.ccc};
        width: 1px;
    }
    z-index: 1;
`;

export const RightBottomHelpPanel = styled.div`
    flex: 0 0 68%;
    max-width: 68%;
    display: flex;
    justify-content: space-between;
    border: 1px solid ${({ theme }) => theme.colors.border.lightGrey};
    border-top: 0;
    background: ${({ theme }) => theme.colors.background.lightGrey};
    border-radius: 0 0 4px 4px;
    line-height: 1.15;
    font-size: 0.65rem;
    font-weight: 600;
    box-shadow: ${({ theme }) => theme.colors.shadow.ccc} 0px 3px 5px 0px;
    height: 24px;
    span {
        font-weight: 400;
    }
    z-index: 1;
`;

export const BottomHelpPanelMenuItem = styled.button`
    padding: 0px 10px;
    font-size: 0.7rem;
    border: 0;
    border-left: 1px solid ${({ theme }) => theme.colors.border.ccc};
    text-align: center;
    display: block;
    background: ${({ theme }) => theme.colors.background.lightGrey};
    cursor: pointer;
    border-radius: 0;
    margin: 0;
    &.first {
        border: 0;
        &:hover {
            border: 0;
            background: ${({ theme }) => theme.colors.background.rotationTree.item};
        }
    }
    &:hover {
        border: 0;
        border-left: 1px solid ${({ theme }) => theme.colors.border.ccc};
        background: ${({ theme }) => theme.colors.background.rotationTree.item};
    }
    &.selected {
        background: ${({ theme }) => theme.colors.background.grey};
    }
`;
